package com.rajen.angrejidictionary.components.sections

import androidx.compose.runtime.Composable
import com.rajen.angrejidictionary.analytics.Umami
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.dom.Div

val HeaderStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .backgroundColor(Color.rgb(0xFF, 0xEC, 0xDE))
        .padding(topBottom = 0.55.cssRem)
        .position(Position.Sticky)
        .top(0.px)
        .zIndex(1000)
        .display(DisplayStyle.Flex)
        .justifyContent(JustifyContent.Center)
        .alignItems(AlignItems.Center)
}

val HeaderShadowStyle = CssStyle.base {
    Modifier
        .position(Position.Absolute)
        .top(100.percent)
        .left(0.px)
        .width(100.percent)
        .height(40.px)
        .backgroundImage(
            linearGradient(
                Colors.Transparent,
                Color.rgba(0, 0, 0, 0.10f),
                LinearGradient.Direction.ToBottom
            )
        )
        .pointerEvents(PointerEvents.None)
        .zIndex(-1)
}

@Composable
fun Header(modifier: Modifier = Modifier) {
    Box(HeaderStyle.toModifier().then(modifier), contentAlignment = Alignment.Center) {
        Link(
            path = "/",
            modifier = Modifier
                .display(DisplayStyle.Flex)
                .justifyContent(JustifyContent.Center)
                .alignItems(AlignItems.Center)
                .cursor(Cursor.Pointer)
                .onClick { Umami.trackLogoClick() }
        ) {
            Image(
                src = "/ad-line-logo.png",
                alt = "Angreji Dictionary Logo",
                modifier = Modifier.height(2.1.cssRem).width(auto)
                    .objectFit(ObjectFit.Contain).cursor(Cursor.Pointer)
            )
        }
    }
}